import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiResponseError } from '../../../../types/errors';
import { useAccountApi } from '../../hooks/use-settings-api';
import type { ConfirmPasswordApiRequest } from '../../types';
import { ConfirmPasswordError } from '../errors';
import { QK_CONFIRMED_PASSWORD_STATUS } from './use-confirmed-password-status';

export function useConfirmPassword() {
  const { accountApi } = useAccountApi();
  const queryClient = useQueryClient();

  async function confirmPassword(data: ConfirmPasswordApiRequest) {
    try {
      await accountApi.confirmPassword(data);
    } catch (err) {
      if (
        ApiResponseError.isApiResponseError(err, ApiResponseError.errorSchemas.message) &&
        err.status === 422
      ) {
        throw new ConfirmPasswordError('incorrect_password');
      }

      throw err;
    }
  }

  return useMutation({
    mutationFn: confirmPassword,
    onSuccess: () => {
      queryClient.setQueryData(QK_CONFIRMED_PASSWORD_STATUS, { confirmed: true });
    },
  });
}
